import React from 'react'
import { Link } from 'react-router'
import config from '../config'
import { useTranslation } from 'react-i18next';

export default function Footer() {
    const { t, i18n } = useTranslation();
    return (
        <footer className="footer">
            <div className="support">
                <div className="support-title"><b>{t("247support")}</b></div>
                <div className="footer-social">
                    <Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}><img src="../images/facebook.png" alt="facebook" /></Link>
                    <Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}><img src="../images/instagram.png" alt="instagram" /></Link>
                    <Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}><img src="../images/telegram.png" alt="telegram" /></Link>
                    <Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}><img src="../images/twitter.png" alt="twitter" /></Link>
                </div>
            </div>
            <div className="footer-menu">
                <ul>
                    <li><a href={`${config.isWhiteLabel ? '/sport' :'/'}`}>{t('About Us')}</a></li>
                    <li><Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}>{t('Terms and Conditions')}</Link></li>
                    <li><Link to={`${config.isWhiteLabel ? '/sport' :'/'}`}>{t('Responsible Gaming')}</Link></li>
                </ul>
            </div>
            <div className="footer-box">
                <div className="footer-top">
                    <div className="secure-logo">
                        <div className="img"><img src="https://wver.sprintstaticdata.com/v106/static/front/img/ssl.png" alt="ssl" /></div>
                        <div className="text"><b>{t("100safe")}</b>
                            <div>{t("protected_connection")}</div>
                        </div>
                    </div>
                    <div className="footer-other">
                        <Link to="/" role="button"><img src="../images/18plus.png" alt="18plus" /></Link>
                        <Link to="/" target="_blank"><img src="../images/gamecare.png" alt="gamecare" /></Link>
                        <Link to="/" target="_blank"><img src="../images/gt.png" alt="gamblingtherapy" /></Link>
                    </div>
                </div>
                <div className="footer-bottom">
                {config.isWhiteLabel ? <></> :<span className="ws-pre-wrap">This website is owned and operated by (WORLD777.COM) Seven
                    Investments America N.V.. registration number: 152581, registered address: Zuikertuintjeweg Z/N (Zuikertuin
                    Tower), Curaçao. Contact us info@world7.com. world7.com is licensed and regulated by the Government of the
                    Autonomous Island of Anjouan, Union of Comoros and operates under License No. ALSI-122310018-F16. world7.com has
                    passed all regulatory compliance and is legally authorized to conduct gaming operations for any and all games of
                    chance and wagering.</span>}
                </div>
            </div>
            <div className="copyright">
                © {t("Copyright")} 2020.
                {t("All Rights Reserved")}
            </div>
        </footer>
    )
}
